/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};



/******/ })()
;

$( document ).ready(function() {
  $(document).on('click','.quantity_controler',function(){
    var _ths = $(this);
    var crnt_value = _ths.parents('.quantity-input').find('.quantity_value').val();
    if(_ths.attr('data-action') == "plus"){
      crnt_value = parseInt(crnt_value)+1;
      _ths.parents('.quantity-input').find('.quantity_value').val(+crnt_value);
      return false;
    }else{
      if(crnt_value != '1'){
        crnt_value = crnt_value-1;
        _ths.parents('.quantity-input').find('.quantity_value').val(crnt_value);
      }
    }
  })
  
  



  $('body').on('change','[filter-by="tag"] input[type="checkbox"]',function(){

    let current_url =  $('.sec1_collection').attr('collection_url');
    if ($(this).is(':checked')) {

      $(this).attr('checked','checked')
    }
    else
    {
      $(this).removeAttr('checked')
    }


    let filter_selected =  $(this).parents('#CollectionFiltersForm').serialize();



    if(filter_selected != '')
    {
      window.location.href = `${current_url}?${filter_selected}`
    }
    else
    {
      window.location.href = `${current_url}`
    }
  });

  $('body').on('change','.collection_sort_filter',function(){
    var vv = $(this).val();
    $('[name="sort_by"]').val(vv)
    let filter_selected =  $('#CollectionFiltersForm').eq(0).serialize();
    let current_url =  $('.sec1_collection').attr('collection_url');
    if(filter_selected != '')
    {
      window.location.href = `${current_url}?${filter_selected}`
    }
    else
    {
      window.location.href = `${current_url}`
    }
  });
  

//   const mouseEvent = e => {
//     const shouldShowExitIntent = 
//           !e.toElement && 
//           !e.relatedTarget &&
//           e.clientY < 10;

//     if (shouldShowExitIntent) {
//       document.removeEventListener('mouseout', mouseEvent);

//       document.querySelector('#myModal1').style.display = "flex";
//     }
//   };
  

//   setTimeout(() => {
//              document.addEventListener('mouseout', mouseEvent);
// }, 45000);


  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let get_off = getCookie("get_off");
    if (get_off != "get_off") {
      document.querySelector('#myModal1').style.display = "flex";
    } 

  }

  


//   setTimeout(() => {
//              checkCookie()
// }, 45000);

$('body').on('click','.get_off_submit',function(){

//   setCookie("get_off", "get_off", 1);
  $(this).siblings('#contact_form').trigger('submit')

});


$(window).on("load resize",function(e){

  if ($(window).width() < 580) {
    let header_height = $('.header__wrapper').innerHeight()
    $('.template-product .main-product__block-title').addClass('title_fixed')
    $('.template-product .main-product__block-title').css('top', header_height )
  }
  else
  {
    $('.template-product .main-product__block-title').removeClass('title_fixed')
  }
  


});
  
  
//   $(window).on("load scroll resize",function(e){
//     $('body').css('--sf-header-height',($('.header__wrapper').innerHeight() )+'px');
//     $('#MainContent').css('padding-top', ($('.header__wrapper').innerHeight()  )+'px' )
//   });

  $('body').on('click','[data-action="custom_addto_wishlist"]',function(){
    $('.sf-wishlist__button').trigger('click')
  });





});